import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getDepartments } from "../../store/actions/departmentActions";
import { Redirect } from 'react-router-dom';
import { Link } from "react-router-dom";

import moment from 'moment';
import LOADER from "../../assets/images/loader.svg";
import { useHistory, useLocation } from 'react-router-dom';



import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";

import Meters from "../../components/Meters/Meters";
import GeneralDashboard from "../../components/Dashboards/General";
import DepartmentDashboard from "../../components/Dashboards/Department";
import RiskDashboard from "../../components/Dashboards/RiskDashboard";


import { resetGotoRiskDashboard } from "../../store/actions/riskActions";
import { resetDepartmentDashboard } from "../../store/actions/departmentActions";


import Select from 'react-select'



const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
        width: '250px',
        marginLeft: '10px',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            // backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};


function Dashboards(props) {

    const { token, departments, getDepartmentsFN, match, resetGotoRiskDashboardFN, resetDepartmentDashboardFN } = props;

    const history = useHistory();
    const location = useLocation();
    const departmentfromredirect = location.state?.departmentfromredirect;

    const departmentOptions = departments && departments.map(department => ({
        value: department.department_id,
        label: department.name
    }));

    useEffect(() => {
        if (departmentfromredirect) {

            //alert(departmentfromredirect);
            let departmentname = departments && departments.find(department => department.department_id === departmentfromredirect);
            setActiveDepartmentId(departmentfromredirect);
            setActiveDepartment(departmentname.name);
            resetDepartmentDashboardFN();
        }
    }, [departmentfromredirect]);

    //const departments = ["General", "Financial", "Marketing", "Pricing", "IT", "HR", "Project", "Management"];
    const [activeDepartment, setActiveDepartment] = useState("General");
    const [activeDepartmentId, setActiveDepartmentId] = useState(null);
    const [activeRiskId, setActiveRiskId] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null); // New state for Select component


    useEffect(() => {
        //resetDepartmentDashboardFN();
        resetGotoRiskDashboardFN();
        getDepartmentsFN();
    }, []);

    useEffect(() => {
        if (match.params.id) {
            setActiveRiskId(match.params.id);
        }
    }, [match.params.id]);



  return token ? (
  <div className="flex flex-col w-full h-screen bg-[#F6F8FA] overflow-hidden">
    {/* TopBar – pinned at top via flex layout */}
    <div className="flex-shrink-0">
      <TopBar />
    </div>

    {/* Main row: Sidebar + scrollable content */}
    <div className="flex min-h-0 min-w-0 w-full flex-1 overflow-hidden">
      {/* Sidebar: drawer on small screens — no flex width reserved */}
      <div className="w-0 min-w-0 overflow-visible md:w-auto md:flex-shrink-0 md:h-full">
        <Sidebar />
      </div>

      {/* Main scroll area — min-w-0 so flex child can shrink and scroll vertically on mobile */}
      <div
        id="dashboard-content"
        className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-y-auto overflow-x-hidden p-2 sm:p-4"
      >
        <div className="flex min-w-0 w-full flex-wrap">
          {activeDepartment !== "General" && (
            <div className="flex items-center">
              {activeRiskId && (
                <button
                  className={`flex-1 p-2 text-l w-32 ${
                    activeDepartment === "General"
                      ? "font-bold bg-[#3b3b3b] text-white"
                      : "bg-transparent text-black"
                  } transition duration-200 rounded-[5px] m-1`}
                >
                  Risk {activeRiskId}
                </button>
              )}

              <button
                className={`flex-1 p-2 text-l w-32 ${
                  activeDepartment === "General" && !activeRiskId
                    ? "font-bold bg-[#3b3b3b] text-white"
                    : "bg-transparent text-black border border-[#3b3b3b]"
                } transition duration-200 rounded-[5px] m-1`}
                onClick={() => {
                  setSelectedDepartment(null);
                  setActiveDepartment("General");
                  setActiveDepartmentId("all");
                  setActiveRiskId(null);
                  if (history.location.pathname !== "/dashboards")
                    history.push("/dashboards");
                }}
              >
                General
              </button>

              {departments.map((department, index) => (
                <button
                  key={index}
                  className={`flex-1 p-2 text-l ${
                    activeDepartment === department.name
                      ? "font-bold bg-[#3b3b3b] text-white"
                      : "bg-transparent text-black"
                  } transition duration-200 rounded-[5px] m-1`}
                  onClick={() => {
                    setActiveDepartment(department.name);
                    setActiveDepartmentId(department.department_id);
                    setActiveRiskId(null);
                    if (history.location.pathname !== "/dashboards")
                      history.push("/dashboards");
                  }}
                >
                  {department.name}
                </button>
              ))}

              <Select
                options={departmentOptions}
                placeholder="Select a department"
                onChange={(e) => {
                  const actual_department = departments.find(
                    (department) => department.department_id === e.value
                  );
                  setActiveDepartment(actual_department.name);
                  setActiveDepartmentId(e.value);
                  setActiveRiskId(null);
                  setSelectedDepartment(e);
                  if (history.location.pathname !== "/dashboards")
                    history.push("/dashboards");
                }}
                styles={customStyles}
                value={selectedDepartment}
              />
            </div>
          )}

          <div className="min-w-0 flex-1">
            {activeDepartment !== "General" && !match.params.id && (
              <Meters mode="department" department_id={activeDepartmentId} />
            )}
            {match.params.id && <Meters mode="risk" risk_id={match.params.id} />}
          </div>
        </div>

        {activeDepartment === "General" && !match.params.id && (
          <div className="mx-auto min-w-0 w-full max-w-full py-2 sm:py-4">
            <GeneralDashboard />
          </div>
        )}

        {activeDepartment !== "General" && !match.params.id && (
          <DepartmentDashboard department_id={activeDepartmentId} />
        )}

        {match.params.id && <RiskDashboard match={match} />}
      </div>
    </div>
  </div>
) : (
  <Redirect to="/login" />
);


}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        departments: state.department.departments,



    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentsFN: () => dispatch(getDepartments()),
        resetGotoRiskDashboardFN: () => dispatch(resetGotoRiskDashboard()),
        resetDepartmentDashboardFN: () => dispatch(resetDepartmentDashboard()),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Dashboards);
